'use client';
import React, { useState, useEffect } from 'react';
import Link from 'next/link';
import AppImage from '@/components/ui/AppImage';

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? 'bg-canopy/90 backdrop-blur-xl border-b border-chartreuse/10'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 h-20 flex items-center justify-between">
        {/* Logo */}
        <Link href="/" className="flex items-center gap-3 group">
          <AppImage
            src="/assets/images/logo/logo_atn2-03.png"
            alt="Agro Teknologi Nusantara"
            width={48}
            height={48}
            className="w-14 h-14 object-contain" />
            
        </Link>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-8">
          {[
            { label: 'Layanan', href: '/#services', status: 'active' },
            { label: 'Program', href: '/#program', status: 'inactive' },
            { label: 'Berita', href: '/#news', status: 'active' },
            { label: 'Tentang', href: '/tentang', status: 'active' },
            { label: 'FAQ', href: '/faq', status: 'active' },
          ].map((item) => (
            <a
              key={item.label}
              href={item.href}
              className={item.status == 'inactive' ? 'text-muted font-mono text-xs tracking-widest uppercase text-text-muted hover:text-chartreuse transition-colors pointer-events-none' : 'font-mono text-xs tracking-widest uppercase text hover:text-chartreuse transition-colors'}
            >
              {item.label}
            </a>
          ))}
        </nav>

        {/* CTA */}
        {/* <div className="flex items-center gap-4">
          <Link
            href="/quote"
            className="btn-chartreuse px-5 py-2.5 rounded-sm text-xs font-mono font-bold tracking-widest uppercase"
          >
            Hubungi Kami
          </Link>
        </div> */}

        {/* Mobile menu toggle */}
        <button
          className="md:hidden flex flex-col gap-1.5 group w-8"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          <div className={`w-full h-0.5 bg-chartreuse transition-all duration-300 ${menuOpen ? 'rotate-45 translate-y-2' : ''}`} />
          <div className={`w-2/3 h-0.5 bg-chartreuse transition-all duration-300 ${menuOpen ? 'opacity-0' : ''}`} />
          <div className={`w-full h-0.5 bg-chartreuse transition-all duration-300 ${menuOpen ? '-rotate-45 -translate-y-2' : ''}`} />
        </button>
      </div>
      {/* Mobile Menu */}
      {menuOpen && (
        <div className="md:hidden bg-canopy/95 backdrop-blur-xl border-t border-chartreuse/10 px-6 py-6 flex flex-col gap-5">
          {[
            { label: 'Layanan', href: '/#services' },
            { label: 'Program', href: '/#program' },
            { label: 'Berita', href: '/#news' },
            { label: 'Tentang', href: '/tentang' },
            { label: 'FAQ', href: '/faq' },
          ].map((item) => (
            <a
              key={item.label}
              href={item.href}
              onClick={() => setMenuOpen(false)}
              className="font-mono text-sm tracking-widest uppercase text-text-muted hover:text-chartreuse transition-colors"
            >
              {item.label}
            </a>
          ))}
          <Link
            href="/quote"
            className="btn-chartreuse px-5 py-3 rounded-sm text-xs font-mono font-bold tracking-widest uppercase text-center"
          >
            Hubungi Kami
          </Link>
        </div>
      )}
    </header>
  );
}
